import api from 'api';
import ApiService from 'api/ApiService';
import {call, put, SagaReturnType} from 'redux-saga/effects';
import i18n from 'i18n';
import {IAdminRole} from 'types/diplomat/settings/adminroles/AdminRole';
import {asyncSagaConstructor, unhandedSagaError} from 'redux/common';
import {pushSuccessToast} from 'features/notifications/redux/actions';
import {settingsTypes} from '..';
import {Action} from 'redux/helpers';
import {openConfirmDialog} from 'redux/common/saga/openConfirmDialog';
import i18next from 'i18next';

export function* deleteAmdinRoleSaga(act: Action<IAdminRole[]>) {
   try {
      const dialogRes = (yield call(
         openConfirmDialog,
         i18next.t('Delete selected Admin Role(s)?')
      )) as SagaReturnType<typeof openConfirmDialog>;
      if (dialogRes && act.payload) {
         yield call(postData, act.payload);
      }
   } catch (e) {
      yield call(unhandedSagaError, e as Error);
   }
}

function* postData(roles: IAdminRole[]) {
   for (let role of roles) {
      yield call(
         asyncSagaConstructor(api.adminroles + `/${role.id}`, settingsTypes.DELETE_ADMIN_ROLE, {
            getMethod: ApiService.deleteSecureJson,
         })
      );
   }

   yield put(pushSuccessToast(i18n.t('Selected roles deleted successfully')));

   yield call(
      asyncSagaConstructor(api.adminroles, settingsTypes.FETCH_ADMIN_ROLES, {
         getMethod: ApiService.getSecureJson,
      })
   );
}
